import React, { useState } from 'react';
import WorkDescriptionForm from './WorkDescriptionForm';
import PriceEstimate from './PriceEstimate';
import ContactForm from './ContactForm';
import SuccessScreen from './SuccessScreen';
import WelcomeScreen from './WelcomeScreen';
import { useQuote } from '../context/QuoteContext';

const QuoteFlow: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const { state } = useQuote();
  const totalSteps = 5;

  const handleNextStep = () => {
    setCurrentStep(prev => Math.min(prev + 1, totalSteps));
  };

  const handlePrevStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 0));
  };

  const stepComponents = [
    <WelcomeScreen key="step0" onNext={handleNextStep} />,
    <WorkDescriptionForm key="step1" onNext={handleNextStep} onBack={handlePrevStep} />,
    <PriceEstimate key="step2" onNext={handleNextStep} onBack={handlePrevStep} />,
    <ContactForm key="step3" onNext={handleNextStep} onBack={handlePrevStep} />,
    <SuccessScreen key="step4" />
  ];

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      {currentStep > 0 && (
        <div className="bg-gray-100 h-1">
          <div 
            className="bg-black h-full transition-all duration-500 ease-out"
            style={{ width: `${((currentStep) / (totalSteps - 1)) * 100}%` }}
          />
        </div>
      )}
      
      <div className="p-4">
        {stepComponents[currentStep]}
      </div>
    </div>
  );
};

export default QuoteFlow;